module.exports = __webpack_public_path__ + "img/banner-news-text.87a621b9.png";